import localStorage from "local-storage-fallback";

import { CLEARED_KEYS_AFTER_LOGOUT } from "src/consts/storage";

export function clearLocalStorageValuesAfterLogout() {
  CLEARED_KEYS_AFTER_LOGOUT.forEach((key) => localStorage.removeItem(key));
}
